import { createStyle } from '@gluestack-style/react';

export const ModalHeader = createStyle({
  px: '$4',
  paddingTop: '$4',
  paddingBottom: '$2',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
});
